<div class="port-calender-inner">
    
    <div class="">
        <div class="select-sec">
            <label>Port</label>
            <div class="select-section-relative">
                <div class="pRel">
                <select class="form-control">
                    <option>
                        Select Port1
                    </option>
                    <option>
                        Select Port
                    </option>
                    <option>
                        Select Port
                    </option>
                </select>
                <span class="downArrow"><img src="../../../../../assets/images/arrow.png" /></span>
            </div>
                <!-- <img src="../../../assets/images/arrow-down-sign-to-navigate.svg"> -->
            </div>
        </div>
    </div>
    <div class="">
        <div class="select-sec">
            <label>vessels</label>
            <div class="select-section-relative">
                <div class="pRel">
                <select class="form-control">
                    <option>
                        Select Port1
                    </option>
                    <option>
                        Select Port
                    </option>
                    <option>
                        Select Port
                    </option>
                </select>
                <span class="downArrow"><img src="../../../../../assets/images/arrow.png" /></span>
            </div>
                <!-- <img src="../../../assets/images/arrow-down-sign-to-navigate.svg"> -->
            </div>
        </div>
    </div>
    <div class="">
        <div class="select-sec">
            <label>Voyage</label>
            <div class="select-section-relative">
                <div class="pRel">
                <select class="form-control">
                    <option>
                        Select Port1
                    </option>
                    <option>
                        Select Port
                    </option>
                    <option>
                        Select Port
                    </option>
                </select>
                <span class="downArrow"><img src="../../../../../assets/images/arrow.png" /></span>
            </div>
                <!-- <img src="../../../assets/images/arrow-down-sign-to-navigate.svg"> -->
            </div>
        </div>
    </div>
    <div class="">
        <div class="select-sec">
            <label>Shipping Line</label>
            <div class="select-section-relative">
                <div class="pRel">
                <select class="form-control">
                    <option>
                        Select Port1
                    </option>
                    <option>
                        Select Port
                    </option>
                    <option>
                        Select Port
                    </option>
                </select>
                <span class="downArrow"><img src="../../../../../assets/images/arrow.png" /></span>
            </div>
                <!-- <img src="../../../assets/images/arrow-down-sign-to-navigate.svg"> -->
            </div>
        </div>
    </div>
    <div class="btn-search">
        <button class="btn  btn-go my-2 my-sm-0" type="submit">
            <img src="../../../assets/images/Group 103.svg">
        </button>
    </div>
</div>
<div class="border-bottom-sec"></div>
<div class="graph-sec">
    <img src="../../../assets/images/graph.png">
</div>